import SignupConsent from './SignupConsent'

export default SignupConsent
